import { useEmployeePhoto } from '@/hooks';
import { usePeoplePickerStyles } from './PeoplePicker.styles';

interface EmployeePhotoProps {
  employeeId: string;
  displayName: string;
}

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) {
    const firstInitial = parts[0]?.charAt(0) ?? '';
    const lastInitial = parts[parts.length - 1]?.charAt(0) ?? '';
    return `${firstInitial}${lastInitial}`.toUpperCase() || '?';
  }
  return (parts[0]?.[0] ?? '?').toUpperCase();
}

export function EmployeePhoto({ employeeId, displayName }: EmployeePhotoProps) {
  const { src, isLoading } = useEmployeePhoto(employeeId);
  const styles = usePeoplePickerStyles();
  const initials = getInitials(displayName);

  if (isLoading || !src) {
    return (
      <div className={styles.avatar} aria-hidden="true">
        {initials}
      </div>
    );
  }

  return (
    <img
      className={styles.avatar}
      src={src}
      alt={displayName}
      onError={(e) => {
        const target = e.currentTarget;
        target.style.display = 'none';
        target.parentElement?.insertAdjacentHTML(
          'afterbegin',
          `<div class="${styles.avatar}" aria-hidden="true">${initials}</div>`
        );
      }}
    />
  );
}
